import React, { useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { AppContext } from "../../../context/ContextApi";
import { Link, useNavigate, redirect } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { BiSave } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import global_variables from "../../controllers/globalVar.js";
import Loader from "../../loading/Loading.js";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";

const validationSchema = Yup.object().shape({});
const Confirm = () => {
    const {individuel, individuelNextStep, individuelPreviousStep, fileName, fileName2, fileName3, isCheck, selectedOption, setSelectedOption, selectedItem,
        setSelectedItem, declareAcceuil, setDeclareAcceuil, successful, setSuccessful, message, setMessage, showAlert, alert, researchResult, setSearchResult,
        dynamicFields, staticFields, staticSelectedCheckboxes, dynamicSelectedCheckboxes, staticBox, dynamicBox, numPolices, userDate, handleEmpty,
    } = useContext(AppContext);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [url, setUrl] = useState("NONE/NONE");
    const navigate = useNavigate();

    const date = new Date(individuel.sousDateNaissance);
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    const formattedDate = date.toLocaleDateString("fr-FR", options);

    const date2 = new Date(userDate);
    const options2 = { year: "numeric", month: "numeric", day: "numeric" };
    const formattedDate2 = date2.toLocaleDateString("fr-FR", options2);

    const date3 = new Date(individuel.defDateDeces);
    const options3 = { year: "numeric", month: "numeric", day: "numeric" };
    const formattedDate3 = date3.toLocaleDateString("fr-FR", options3);

    const handleSubmit = (values) => {
        individuelNextStep(values);
    };
    const handleBack = (values) => {
        individuelPreviousStep(values);
    };

    const handleValidation = useCallback(
        (values) => {
        setLoading(true);
        //implementing today's date params
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = today.getFullYear();
        today = yyyy + "-" + mm + "-" + dd;

        // //implementing polices params
        let userPolices = [];
        isCheck.forEach(function(item, i) {
            userPolices[i] = item;
        });

        // //implementing pieces_assure params
        let test = [];
        test.push("1");
        let nature = "scanne";
        test.push(`${nature}`);
        let img = staticFields.file;
        test.push(`${img}`);
        let pieces_assure = [];
        pieces_assure.push(test);

        // //implementing declarant contact
        let declaContact = [];
        declaContact.push(`${values.declaContact}`, `${values.autreContact}`);

        let pieces_beneficiaire = [];

        dynamicFields.forEach((each, index) => {
            pieces_beneficiaire.push([
                `${each.newFileId}`,
                `${each.dropdownValue}`,
                null,
                "scanne",
                `${each.file}`,
            ]);
        });

        const postme = {
            date_declaration: today,
            polices: numPolices,
            nom_client: values.sousNom,
            prenoms_client: values.sousPrenom,
            date_naissance_client: values.sousDateNaissance,
            assure: values.assure,
            date_naissance: values.defDateNaissance,
            date_deces: values.defDateDeces,
            lieu_deces: values.defLieuDeces,
            cause_deces: values.cause_deces,
            civilite_declarant: values.civilite,
            declarant: values.declaNom + " " + values.declaPrenom,
            qualite_declarant: values.qualite_declarant,
            contact_declarant: declaContact,
            email_declarant: [values.declaAdressElectro],
            adresse_declarant: values.declaAdressePost,
            pieces_assure: pieces_assure,
            pieces_beneficiaire: pieces_beneficiaire,
        };

        var config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${
              global_variables().SINISTRE_CARE_WEBSERVICE
            }/declaration-sinistre`,
            headers: {
              "Content-Type": "application/json",
            },
            data: JSON.stringify(postme),
        };

        axios(config)
            .then(function(response) {
                if (response.data.status === true) {
                    localStorage.setItem("numero", JSON.stringify(response.data));
                    toast.success("Enregistrement réussi.", {
                        position: "top-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",
                    });
                    handleEmpty(navigate, "success");
                } else {
                    setLoading(false);
                    toast.error(
                        `${response.data.error} `,
                        {
                            position: "top-center",
                            autoClose: 10000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",
                        }
                    );
                }
            })
            .catch(function(error) {
                  setLoading(false);
                  // showAlert("Une erreur  s'est produite", 'error')
                  toast.error(
                        "Désolé, votre déclaration n’a pas abouti. Nous vous invitons svp à réessayer ou à nous contacter en appelant le 1354.",
                        {
                          position: "top-center",
                          autoClose: 10000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                          theme: "dark",
                        }
                  );
                  console.log(error);
            });
        },
        [selectedOption, selectedItem, setSearchResult, researchResult]
    );

    return (
            <Formik validationSchema={validationSchema} initialValues={individuel} onSubmit={handleSubmit}>
                {({ values }) => (
                    <Form>
                        <h4 className="section-title section-title-mobile mb-4">RESUME DES INFORMATIONS SAISIES</h4>
                        <div className="row flex cutom-box">
                            <dl className="col-md-6 custom-with text-secondary divide-y divide-gray-200 sous-resume">
                                <div className="font-info py-2 text-xl text-center">SOUSCRIPTEUR & DEFUNT</div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        SOUSCRIPTEUR :
                                        <span className="ml-2 custom-with-label mt-2 leading-3">{individuel.sousNom} {individuel.sousPrenom}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        DATE DE NAISSANCE : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{formattedDate}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        CONTACT : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.sousContactTel}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        EMAIL : <span
                                        className=" text-white ml-2 custom-with-label mt-2 leading-3">{individuel.sousAdressePostale}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        DEFUNT :
                                        <span className="ml-2 custom-with-label mt-2  leading-3">{individuel.assure}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className=" custom-with-label">
                                        DATE DE NAISSANCE : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{formattedDate2}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        LIEU DE NAISSANCE : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.defLieuNaissance}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        PROFESSION : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.defProfession}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className=" custom-with-label">
                                        DATE DE DECES : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{formattedDate3}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className=" custom-with-label">
                                        LIEU DE DECES : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.defLieuDeces}</span>
                                    </dt>
                                </div>
                            </dl>
                            <dl className="col-md-6 custom-with text-secondary divide-y divide-gray-200 sous-defunt">
                                <div
                                    className="font-info py-2 custom-with-label text-xl border-b text-center font-sans font-normal border-b border-grey-lighter">
                                    DECLARANT & DOCUMENTS JOINTS
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        DECLARANT : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.declaNom} {individuel.declaPrenom}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        LIEN DE PARENTE : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.qualite_declarant}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        CONTACT : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.declaContact}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        AUTRE CONTACT : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.autreContact}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        EMAIL : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.declaAdressElectro}</span>
                                    </dt>
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        ADRESSE POSTALE : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">{individuel.declaAdressePost}</span>
                                    </dt>
                                </div>
                                <div className="flex flex-wrap p-2 cutom-box">
                                    <dt className="fcustom-with-label">POLICES :</dt>
                                    {numPolices.map((itemChecked, index) => {
                                        return (
                                            <div key={index}>
                                                <dd key={index}
                                                    className="ml-2 custom-with-label mt-2 leading-3">
                                                    {itemChecked} {(itemChecked.length < 2 || index === (itemChecked.length - 1)) ? "" : ","}
                                                </dd>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="flex p-2 cutom-box">
                                    <dt className="custom-with-label">
                                        DOCUMENTS REQUIS : <span
                                        className="ml-2 custom-with-label mt-2 leading-3">Acte de décès</span>
                                    </dt>
                                </div>
                                {dynamicFields.length > 0 ? (
                                    <div className="flex p-2 cutom-box">
                                        <dt className="custom-with-label">
                                            Autres documents :
                                            {dynamicFields.map((dynamicField, index) => {
                                                return (
                                                    <div key={index}>
                                                        <span
                                                            className="ml-2 custom-with-label mt-2 leading-3">
                                                            {dynamicField.dropdownValue}{" "}
                                                            {(dynamicFields.length < 2 || index === (dynamicFields.length - 1)) ? "" : ", "}
                                                        </span>
                                                    </div>
                                                );
                                            })}
                                        </dt>
                                    </div>
                                ) : null}
                            </dl>
                        </div>

                        {loading ? (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                                <Loader/>
                            </div>
                        ) : (
                            <div className="flex mt-4 justify-center align-center text-center btn-container souscripteur-btn-mobile">
                                <button onClick={() => handleBack("")} type="button"
                                        className="d-flex justify-center items-center btn bts-sm btn-primary mx-2 rounded-pill">
                                    <IoIosArrowBack className="mr-2"/> Précédent
                                </button>
                                <button onClick={() => handleValidation(values)} type="submit"
                                        className="d-flex justify-center items-center btn bts-sm btn-warning mx-2 rounded-pill">
                                    Enregistrer <BiSave className="ml-2"/>
                                </button>
                            </div>
                        )}
                    </Form>
                )}
            </Formik>
    );
};

export default Confirm;
